<script>
    import { afterUpdate, onMount } from "svelte";
import { push } from "svelte-spa-router";
    import AddSectionButton from "../components/AddSectionButton.svelte";
import Block from "../components/Block.svelte";
    import SimpleBackNav from "../components/donorflow-ui/SimpleBackNav.svelte";
    import Section from "../components/Section.svelte";
import Share from "../components/Share.svelte";
    import { sections, page } from "../stores";

    export let params;

    let db, portalId, loading;
    let jq;

    function getPage(){
        loading = true;
        db.collection('pages')
            .doc(params.id)
            .get()
            .then(doc => {
                if(doc.exists){
                    let d = {
                        id: doc.id,
                        ...doc.data()
                    };
                    $page = d;
                    $sections = d.layout.sections;
                    console.log($sections);
                    loading = false;
                }
            })
            .catch(e => console.log(e));
    }

    function addSection() {
        $sections = [
            ...$sections,
            {
                id: 543,
                sortOrder: sections.length + 1,
                rows: [
                    {
                        cols: [
                            {
                                blocks: [
                                    {
                                        contentType: "text",
                                        content: "Edit text here...",
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ];
    }

    function removeSection() {}

    async function save() {
        $page.layout.sections = $sections;
        await db.collection('pages').doc(params.id).set($page);
        
    }

    function preview(){
        push('/view/'+params.id);
    }
    function share(){
        jq('#exampleModal').modal()
    }

    onMount( async () => {
        if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }
      jq = window.$;
  
      portalId = localStorage.getItem("portal");
  
      db = firebase.firestore();

      await getPage();
    })

    afterUpdate(() => {
        $sections = $sections;
    })
</script>
{#if !loading}
<SimpleBackNav
    to="/"
    hideBackLink={false}
    title={$page.name}
    buttons={[
        {
            label: '⚡️ Save changes',
            action: save,
            class: 'btn btn-outline-dark btn-small mr-3'
        },
        {
            label: '🔗 Share',
            action: share,
            class: 'btn btn-outline-dark btn-small mr-3'
        },
        {
            label: '👀 View page',
            action: preview,
            class: 'btn btn-outline-dark btn-small mr-3'
        }
    ]}
/>
<Share id={params.id} />
{#each $sections as section, i}
    <Section {section} index={i} />
{/each}
<AddSectionButton {addSection} />
{/if}

